import script from "./WebinarMediaPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarMediaPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./WebinarMediaPickerModal.vue?vue&type=style&index=0&id=33405be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33405be4"]])

export default __exports__